import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonAppearance, ButtonSize } from '@vsolv/vectors-ui/button';
import { IconName } from '@vsolv/vectors-ui/icons';
import { ThemeColor } from '@vsolv/vectors-ui/theming';
import { TooltipContent, TooltipDirectiveConfig } from '@vsolv/vectors-ui/tooltip';
import { TableCellComponent } from '../../models';

export interface ButtonCellProps {
  theme?: ThemeColor;
  size?: ButtonSize;

  type?: ButtonAppearance;
  rounded?: boolean;
  disabled?: boolean;

  text?: string;
  iconStart?: IconName;
  iconEnd?: IconName;

  routerLink?: string[];
  click?(): void | Promise<void>;

  extraClasses?: string;

  tooltip?: {
    content: TooltipContent;
    config?: TooltipDirectiveConfig;
  };
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <ng-container *ngIf="data && (data.text || data.iconStart || data.iconEnd)">
      <div
        [className]="data.extraClasses"
        (click)="data.disabled && $event.stopImmediatePropagation()"
        [vsTooltip]="data.tooltip?.content"
        [tooltipConfig]="data.tooltip?.config"
      >
        <a
          *ngIf="data.routerLink; else buttonTmpl"
          vs-button
          [theme]="data.theme"
          [size]="data.size ?? 'md'"
          [routerLink]="data.routerLink"
          [appearance]="data.type || 'default'"
          [rounded]="data.rounded || false"
          [disabled]="data.disabled || false"
          (click)="$event.stopPropagation()"
        >
          <vs-icon *ngIf="data.iconStart" [name]="data.iconStart" slot="start"></vs-icon>
          <span>{{ data.text }}</span>
          <vs-icon *ngIf="data.iconEnd" [name]="data.iconEnd" slot="end"></vs-icon>
        </a>

        <ng-template #buttonTmpl>
          <button
            vs-button
            type="button"
            [theme]="data.theme"
            [size]="data.size ?? 'md'"
            [appearance]="data.type || 'default'"
            [rounded]="data.rounded || false"
            [disabled]="data.disabled || false"
            (click)="$event.stopPropagation(); _click()"
          >
            <vs-icon *ngIf="data.iconStart" [name]="data.iconStart" slot="start"></vs-icon>
            <span>{{ data.text }}</span>
            <vs-icon *ngIf="data.iconEnd" [name]="data.iconEnd" slot="end"></vs-icon>
          </button>
        </ng-template>
      </div>
    </ng-container>
  `,
})
export class ButtonCellComponent extends TableCellComponent<ButtonCellProps> {
  async _click() {
    await this.data?.click?.();
  }
}
